import { Popover, PopoverBody, PopoverContent, PopoverTrigger, useCheckboxGroup } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ITagsData } from "src/api/server/extended-search";
import { PopoverButton } from "src/components/pages/search/components/popover-button";
import { TagsFilterBodyContent } from "src/components/pages/search/components/tags-filter/tags-filter-body-content";
import { IChangeFilterTag } from "src/components/pages/search/components/types";
import { SAVINGS_PLAN_TAG } from "src/components/pages/search/constants";
import { ISearch } from "src/components/pages/search/search.types";
import { handleResetTags, handleTags } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";

const TAGS_POPOVER_BUTTON_TEST_ID = "tags-popover-button";

interface ITagsPopover extends ISearch {
    tagsData: ITagsData;
}

export const TagsPopover = ({ tagsData, onSearch }: ITagsPopover) => {
    const { t } = useTranslation("extended-search");
    const { getCheckboxProps } = useCheckboxGroup();
    const { tags: selectedTags } = useSearchStore();

    const { basics, tradings, rewards, investmentHorizon, investmentRegion } = tagsData.tags;
    const numbersOfTags =
        basics.tags.length + tradings.tags.length + rewards.tags.length + investmentHorizon.tags.length + investmentRegion.tags.length;
    const showBrokers = selectedTags.some(tag => tag.value === SAVINGS_PLAN_TAG);

    const onTagChange = ({ isChecked, value, isPopular }: IChangeFilterTag) => {
        handleTags({ isChecked, value, isPopular, tagsData: tagsData.tags, onSearch });
    };

    const resetTags = () => {
        handleResetTags(onSearch);
    };

    return (
        <Popover placement="bottom-end" flip={false}>
            {({ isOpen }) => (
                <>
                    <PopoverTrigger>
                        <PopoverButton
                            flex={1}
                            isOpen={isOpen}
                            title={t("tags")}
                            badgeInfo={`${selectedTags.length} / ${numbersOfTags}`}
                            data-test-id={TAGS_POPOVER_BUTTON_TEST_ID}
                        />
                    </PopoverTrigger>
                    <PopoverContent w="487px">
                        <PopoverBody p={3}>
                            <TagsFilterBodyContent
                                onSearch={onSearch}
                                showBrokers={showBrokers}
                                getCheckboxProps={getCheckboxProps}
                                tagsData={tagsData}
                                resetTags={resetTags}
                                onChange={onTagChange}
                            />
                        </PopoverBody>
                    </PopoverContent>
                </>
            )}
        </Popover>
    );
};
